import * as types from './actionTypes'

const initialState = {
    isLoading: false,
    entities: [],
    createdCol: null
}

export default (state = initialState, action) => {
    switch (action.type) {
        case types.ENTITIES_FETCH_SUCCESS:
            return {
                ...state,
                entities: [
                    ...action.data
                ]
            }

        case types.ENTITIES_FETCH_FAILED:
            return {
                ...state
            }

        case types.RENAME_ENTITY_SUCCESS:
            return {
                ...state
            }

        case types.RENAME_ENTITY_FAILED:
            return {
                ...state
            }

        case types.RENAME_COL_SUCCESS:
            return {
                ...state
            }

        case types.RENAME_COL_FAILED:
            return {
                ...state
            }

        case types.DELETE_COL_FETCH:
            return {
                ...state,
                isLoading: true
            }

        case types.DELETE_COL_SUCCESS:
            return {
                ...state,
                isLoading: false
            }

        case types.DELETE_COL_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.ADD_COL_FETCH:
            return {
                ...state,
                isLoading: true
            }

        case types.ADD_COL_SUCCESS:
            return {
                ...state,
                isLoading: false,
                createdCol: action.col.id
            }

        case types.ADD_COL_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.RESET_CREATED_COL:
            return {
                ...state,
                createdCol: null
            }

        case types.CHANGE_TYPE_SUCCESS:
            return {
                ...state
            }

        case types.CHANGE_TYPE_FAILED:
            return {
                ...state
            }

        case types.ENTITY_DELETE:
            return {
                ...state,
                isLoading: true
            }

        case types.ENTITY_DELETE_SUCCESS:
            return {
                ...state,
                isLoading: false
            }

        case types.ENTITY_DELETE_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.SET_DEFAULT_VALUE_SUCCESS:
            return {
                ...state
            }

        case types.SET_DEFAULT_VALUE_FAILED:
            return {
                ...state
            }

        default:
            return state
    }
}
